import styled from 'styled-components';
import { colorVariables } from 'theme/variables';
import { Icon, Title } from 'components';

export const PaymentMethodCardStyled = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  border: 1px solid ${colorVariables.white_verylightgainsboro};
  background-color: white;
  text-decoration: none;
  margin-bottom: 10px;
  transition: 75ms ease-in;
  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border: 1px solid ${colorVariables.blue_navyblue};
    transition: 135ms ease-out;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: left;
  width: calc(100% - 30px);
  transition: 75ms ease-in;
`;

export const StyledIcon = styled(Icon)`
  position: relative;
  flex-basis: 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledTitle = styled(Title)`
  position: relative;
  flex-basis: calc(100% - 38px);
  padding-left: 15px;
`;
